export enum ActivityType {
   
    goods_20250216 = 'goods_20250216',
    goods_20250614 = 'goods_20250614'
}


export enum SendStatus {
    All = 'all',
    Send = 1,
    unSend = 0,
    Fail = -1,
};

export const SendStatusName = {
    [SendStatus.All]: {
        title: '全部',
        text: '全部',
        color: 'red',
    },
    [SendStatus.Fail]: {
        title: '推送失败',
        text: '推送失败',
        color: 'red'
    },
    [SendStatus.unSend]:  {
        title: '未推送',
        text: '未推送',
        color: 'gray'
    },
    [SendStatus.Send]:  {
        title: '推送成功',
        text: '推送成功',
        color: 'green'
    },
}


